import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-edit-icon',
	templateUrl: './edit-icon.component.html',
})
export class EditIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
